import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/catalog/processes/$processId/categories/$categoryId/products')({
  component: Outlet,
});
